import React from 'react';
import PropTypes from 'prop-types';


const ConversionTableCellResult = ({ rate, fee, amount }) => {
  let result = amount * rate;

  if (fee > 0) {
    result += (result * fee);
  }

  return (<div>{result.toFixed(2).toString().replace('.', ',')}</div>);
};

ConversionTableCellResult.propTypes = {
  amount: PropTypes.number.isRequired,
  fee: PropTypes.number.isRequired,
  rate: PropTypes.number.isRequired,
};


export default ConversionTableCellResult;



// WEBPACK FOOTER //
// ./src/components/calculator/conversion-table/ConversionTableCellResult.js